import React, { useEffect, useState } from "react";
import Select from "react-select";
import * as Masks from "../../helpers/masks";

import { createOptions } from '../../helpers/selects';

// O react-select fica totalmente "sem chrome": sem borda, fundo ou sombra
// próprios. A moldura, o divisor e o anel de foco vivem no container
// `.filter-simple` / `.filter-select` (styles.scss). Exportado para que
// outros selects de filtro (ex.: categoria em /product/list) reusem o mesmo
// visual — basta envolvê-lo num `.filter-select`.
export const filterSelectStyles = {
    container: (provided) => ({
      ...provided,
      width: '100%',
    }),
    control: (provided) => ({
      ...provided,
      width: '100%',
      minHeight: '33px',
      height: '33px',
      backgroundColor: 'transparent',
      border: 'none',
      borderRadius: 0,
      boxShadow: 'none',
      cursor: 'pointer',
      fontSize: '14px',
    }),
    valueContainer: (provided) => ({
      ...provided,
      height: '33px',
      padding: '0 4px 0 12px',
      display: 'flex',
      flexWrap: 'nowrap',
      alignItems: 'center',
      overflow: 'hidden',
    }),
    input: (provided) => ({
      ...provided,
      margin: 0,
      padding: 0,
    }),
    singleValue: (provided) => ({
      ...provided,
      margin: 0,
      maxWidth: '100%',
      overflow: 'hidden',
      textOverflow: 'ellipsis',
      whiteSpace: 'nowrap',
      color: '#1A1530',
    }),
    placeholder: (provided) => ({
      ...provided,
      margin: 0,
      color: '#9B9B9B',
      overflow: 'hidden',
      textOverflow: 'ellipsis',
      whiteSpace: 'nowrap',
    }),
    indicatorsContainer: (provided) => ({
      ...provided,
      height: '33px',
    }),
    indicatorSeparator: () => ({
      display: 'none',
    }),
    dropdownIndicator: (provided) => ({
      ...provided,
      padding: '0 8px',
      color: '#9B9B9B',
      ':hover': { color: '#4D3DAB' },
    }),
    menu: (provided) => ({
      ...provided,
      zIndex: 10,
      minWidth: '160px',
      borderRadius: '12px',
      border: '1px solid #DDD9F0',
      boxShadow: '0 4px 12px rgba(26, 21, 48, 0.08), 0 2px 4px rgba(26, 21, 48, 0.04)',
      overflow: 'hidden',
    }),
    option: (provided, state) => ({
      ...provided,
      fontSize: '13px',
      backgroundColor: state.isSelected ? '#4D3DAB' : state.isFocused ? '#F5F4FB' : 'transparent',
      color: state.isSelected ? '#fff' : '#1A1530',
      cursor: 'pointer',
      ':active': {
        backgroundColor: state.isSelected ? '#4D3DAB' : '#EDEAF7',
      },
    }),
}

export const FilterSimple = ({params, filter, externalValue, setExternalValue, externalOption, width}) => {
    const options = createOptions(params, 'name', 'key');

    const [option, setOption] = useState(options[0]);
    const [type, setType] = useState('');
    const [operation, setOperation] = useState('');
    const [mask, setMask] = useState(null);
    const [value, setValue] = useState('');

    useEffect(() => {
        let current = params.filter(param => param.key === option.value);
        setType(current[0].type);
        setOperation(current[0]?.operation ?? 'contain');
        setMask(current[0]?.mask ?? null);
    }, [option]);

    useEffect(() => {
        if (externalValue === undefined) return;

        if (externalValue !== value) {
            setValue(externalValue);
        }
    }, [externalValue]);

    useEffect(() => {
        if (externalOption === undefined) return;

        const selectedOption = options.find(option => option.value === externalOption);
        if (selectedOption && selectedOption.value !== option.value) {
            setOption(selectedOption);
        }
    }, [externalOption]);

    const handleKeyDown = (event) => {
        if (event.key === 'Enter') {
            filter(`filters[0]${option.value}[${operation}]=${value}`, {
                field: option.value,
                operation,
                value,
            });
        }
    }

    const handleValueChange = value => {
        let maskedValue = applyMask(value);
        if(typeof setExternalValue === 'function'){
            setExternalValue(maskedValue);
        }
        setValue(maskedValue);   
    }

    const applyMask = value => {
        let maskedValue = value;
        if(mask){
            maskedValue = Masks[mask](value);
        }

        return maskedValue;
    }

    const hasInput = type === 'text' || type === 'email';

    return (
        <div
            className={`filter-simple${hasInput ? ' has-input' : ''}`}
            style={hasInput && width ? { width } : undefined}
        >
            {hasInput &&
                <input
                    type={type}
                    placeholder="Buscar"
                    value={value}
                    onChange={e => handleValueChange(e.target.value)}
                    onKeyDown={handleKeyDown}
                />
            }
            <div className="filter-simple__select">
                <Select options={options} value={option} onChange={setOption} styles={filterSelectStyles} />
            </div>
        </div>
    );
}

export default FilterSimple;
